<template>
    <v-card class="my-2">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>{{ count }} {{ title }}</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="refresh()">Refresh</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            count: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
            }
        },
        methods: {
            refresh() {
                this.$emit("refreshData");
            }
        }
    }
</script>